import React from 'react';
import { Grid, Paper, Typography } from '@material-ui/core';
import moment from 'moment';
import TradingViewWidget from 'react-tradingview-widget';
import styles from './OptionsBoardStyles';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

const RightSidebar = () => {
  const { appReducer, optionChainReducer } = useSelector((state) => state);
	let { ticker } = useParams();
  const {
    articles,
  } = appReducer;
  const { zoompercent } = optionChainReducer;
  const width = '100%';
  return (
    <Grid item xs={12} md={4} lg={4} xl={4} style={{ height: '100%' }}>
      <div
        style={{
          height: 'calc(100%)',
          paddingTop: '25px',
          paddingBottom: '30px',
          boxSizing: 'border-box',
          zoom: zoompercent,
        }}
      >
        <div style={styles.stockContainer}>
          {ticker && (
            <Paper elevation={5} style={styles.stockPaper} className="sticky">
                <TradingViewWidget
                  symbol={ticker}
                  referral_id="13279"
                  width={width}
                  height={250}
                  hide_legend={true}
                  hide_ideas={true}
                  save_image={false}
                  toolbar_bg="#f1f3f6"
                  container_id="basic-area-chart"
                />
                <Typography
                  variant="body1"
                  component="p"
                  style={{
                    ...styles.stockDelayText,
                    fontSize: window.innerWidth < 1440 ? 11 : 12,
                  }}
                >
                  Stock prices in chart are delayed by 15 minutes.
                </Typography>
            </Paper>
          )}
        </div>
        <div style={styles.articlesTitleFixed}></div>
        <div
          style={
            window.innerWidth < 1800
              ? styles.articlesFixedSmall
              : styles.articlesFixed
          }
        >
          {articles.map((article, mKey) => {
            return (
              <div
                key={mKey}
                style={{
                  ...styles.newsContainer,
                  height: window.innerWidth > 2200 ? '7rem' : '4rem',
                }}
              >
                <div>
                  <img
                    style={styles.leftNewsPic}
                    src={article.image_url}
                    alt=""
                  />
                </div>
                <div style={styles.rightNews}>
                  <a href={article.news_url} target="_blank">
                    {article.title.length > 50
                      ? article.title.substring(0, 49) + '...'
                      : article.title}
                  </a>
                </div>
                <div style={{ fontSize: '0.8rem' }}>
                  {moment(article.date).format('MM/DD/YYYY')}
                  {' | By: ' + article.source_name + ' | '}
                  <span
                    style={
                      article.sentiment === 'Neutral'
                        ? { color: 'gray' }
                        : article.sentiment === 'Negative'
                        ? { color: 'red' }
                        : { color: 'green' }
                    }
                  >
                    {article.sentiment}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Grid>
  );
};

export default RightSidebar;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/RightSidebar.jsx